import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Calendar, MapPin, Hotel as HotelIcon, Plane, LogOut, ExternalLink, Settings, Menu, X, Car } from 'lucide-react';
import { clearToken } from '../lib/api';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_travel-booking-hub-90/artifacts/txbpb6pw_20260506_060747_0000.png';

const items = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/reservations', label: 'Reservas', icon: Calendar },
  { to: '/admin/excursions', label: 'Excursiones', icon: MapPin },
  { to: '/admin/vehicles', label: 'Vehículos', icon: Car },
  { to: '/admin/hotels', label: 'Hoteles', icon: HotelIcon },
  { to: '/admin/airports', label: 'Aeropuertos', icon: Plane },
  { to: '/admin/settings', label: 'Configuración', icon: Settings },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const logout = () => {
    clearToken();
    navigate('/admin/login');
  };

  // Close sidebar when navigating on mobile
  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const Sidebar = (
    <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-black border-r border-white/5 flex flex-col transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
      <div className="p-6 border-b border-white/5 flex items-center justify-between">
        <Link to="/" onClick={() => setOpen(false)}><img src={LOGO_URL} alt="TTS" className="h-20 w-auto" /></Link>
        <button onClick={() => setOpen(false)} className="lg:hidden text-white/70 hover:text-white p-1"><X className="w-5 h-5" /></button>
      </div>
      <nav className="flex-1 px-3 py-6 space-y-1 overflow-y-auto">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive ? 'bg-[#ff6b1a] text-white' : 'text-white/70 hover:bg-white/5 hover:text-white'
              }`}
          >
            <it.icon className="w-4 h-4" /> {it.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/5 space-y-1">
        <Link to="/" className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-white/70 hover:bg-white/5 hover:text-white"><ExternalLink className="w-4 h-4" /> Ver Sitio</Link>
        <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-white/70 hover:bg-white/5 hover:text-red-400 transition-colors">
          <LogOut className="w-4 h-4" /> Cerrar Sesión
        </button>
      </div>
    </aside>
  );

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex">
      {/* Mobile overlay */}
      {open && (
        <div onClick={() => setOpen(false)} className="lg:hidden fixed inset-0 bg-black/60 z-40 backdrop-blur-sm" />
      )}
      {Sidebar}

      <main className="flex-1 min-w-0 overflow-auto">
        {/* Mobile top bar */}
        <div className="lg:hidden sticky top-0 z-30 bg-black border-b border-white/5 flex items-center justify-between p-4">
          <button onClick={() => setOpen(true)} className="text-white p-2 -ml-2 rounded-md hover:bg-white/5">
            <Menu className="w-6 h-6" />
          </button>
          <Link to="/"><img src={LOGO_URL} alt="TTS" className="h-12 w-auto" /></Link>
          <div className="w-9" />
        </div>

        <div className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
